export default "__VITE_ASSET__CWSUmhWT__"